var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDownSimple16Regular(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.25752 4.85491C1.42449 4.70102 1.6846 4.71164 1.83848 4.87861L5.61107 8.97212C5.82068 9.19945 6.17935 9.19931 6.3886 8.97222L6.38863 8.97219L10.1615 4.8786C10.3154 4.71163 10.5755 4.70103 10.7425 4.85492C10.9095 5.00881 10.9201 5.26891 10.7662 5.43588L6.99331 9.52944C6.45828 10.1101 5.54169 10.1099 5.00654 9.52953L5.00647 9.52946L1.23381 5.43587C1.07993 5.2689 1.09054 5.00879 1.25752 4.85491Z",
    fill: "#9FA4AB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDownSimple16Regular);
export default __webpack_public_path__ + "static/media/icon_down_simple_16_Regular.847b269a.svg";
export { ForwardRef as ReactComponent };